import { useQuery } from '@tanstack/react-query';
import instance from '@src/api/axiosInstance';
import { trackQueryError } from '@src/utils/sensor/apptracker';
import { get } from 'lodash';

const useDefaultApp = () => {
  const { data, error, isLoading } = useQuery(['nav', 'default-landing-app'], async () => {
    const res = await instance.get('/default-landing-app');
    return get(res, 'data', {});
  }, {
    retry: 1,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    notifyOnChangeProps: ['data', 'error', 'isLoading'],
    onError: (err) => {
      trackQueryError({ type: 'nav-default-landing-app', err });
    },
  });
  return {
    data,
    error,
    loading: isLoading || !data,
  };
};


export default useDefaultApp;
